import React from "react";
import { Header, Divider, Image, Container } from "semantic-ui-react";
const imageList = [
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/quizegg%2Fegg_laugh.svg?alt=media&token=f0115031-cabd-48a9-890d-b3be5abec59e",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/quizegg%2Fquiz-egg-logo.png?alt=media&token=75f7bc80-fea9-46c7-afd3-c99d12aab77d",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/quizegg%2Fquiz_screen.png?alt=media&token=813ad6d2-b410-4534-88e7-ef65f6caea71",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/quizegg%2Fwindow.png?alt=media&token=84bf0500-74d5-4950-a48d-d652aa87c7f5"
];
export const quiz_egg = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Quiz Egg</Header.Content>
        <Header.Subheader>
          <p>
            It's a realtime quiz about everything. Some of the screen shots.
          </p>
          <p>Credit : Designed and developed</p>
        </Header.Subheader>
      </Header>
      <Divider />
      <Image.Group size="medium">
        {imageList.map((url, i) => {
          return <Image key={i} src={url} rounded />;
        })}
      </Image.Group>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/quiz_egg.js